import { toSearchString } from 'tradera-utils/url';
import { touchWebClient } from 'tradera-utils/http';
import { axiosConfigs } from 'tradera-utils/api';

const ENDPOINTS = {
    SAVED_SEARCH_ADD: 'my/savedsearches/add',
    SAVED_SEARCH_NOTIFICATION: 'my/savedsearches/notification',
    SAVED_SEARCH_REMOVE: 'my/savedsearches/remove'
};

const postWithCredentials = async (url, payload) => {
    const { data } = await touchWebClient.post(url, payload, {
        ...axiosConfigs.authenticated
    });
    return data;
};

const saveSearch = async (savedSearchName, categoryId, queryParams) => {
    const payloadObject = {
        savedQueryName: savedSearchName,
        categoryId,
        ...queryParams
    };

    const payload = toSearchString(payloadObject, {
        addQueryPrefix: false
    });
    const url = ENDPOINTS.SAVED_SEARCH_ADD;
    return await postWithCredentials(url, payload);
};

const removeSavedSearch = async savedSearchId => {
    const url = ENDPOINTS.SAVED_SEARCH_REMOVE;
    const payload = toSearchString(
        { ids: savedSearchId },
        { addQueryPrefix: false }
    );
    return await postWithCredentials(url, payload);
};

const saveEmailNotificationEnabled = async (searchId, shouldSend) => {
    const url = ENDPOINTS.SAVED_SEARCH_NOTIFICATION;
    const payload = toSearchString(
        {
            SearchId: searchId,
            SendMail: shouldSend
        },
        {
            addQueryPrefix: false
        }
    );
    return await postWithCredentials(url, payload);
};

export default {
    saveSearch,
    removeSavedSearch,
    saveEmailNotificationEnabled
};
